import { render, staticRenderFns } from "./FudaoEvaluateTeacherDialog.vue?vue&type=template&id=0d35cec6&scoped=true&"
import script from "./FudaoEvaluateTeacherDialog.vue?vue&type=script&lang=js&"
export * from "./FudaoEvaluateTeacherDialog.vue?vue&type=script&lang=js&"
import style0 from "./FudaoEvaluateTeacherDialog.vue?vue&type=style&index=0&id=0d35cec6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d35cec6",
  null
  
)

export default component.exports